import { createSelector } from 'reselect';
import { RootState } from '../../../../types';
import { EntityTypes } from '../../../../constants/entities';
import { IScene } from 'types/domain/scene';
import { IImageFile, Resolutions } from 'types/domain/image';
import { IEntityReducer } from 'core/reducers/entities';
import { getPreferedImageFile } from 'core/sagas/product/assets/parse';
import { IVideoFile, VideoType } from 'types/domain/video';
import { PortraitState } from 'core/slices/player';

const entity = (state: RootState) => state.entity.present;
const id = (state: RootState, id?: number) => id || state.state[EntityTypes.SCENE];
const portrait = (state: RootState) => state.core.player.state.portrait;

export const selectScenePreview = createSelector([entity, id, portrait], (entity: IEntityReducer, id, portrait) => {
  return getScenePreview(entity, id, portrait !== PortraitState.NOT_PORTRAIT);
});

export function getScenePreview(entity, id, portrait = false) {
  const scene: IScene = entity[EntityTypes.SCENE][id];

  if (!scene) return null;

  if (scene.videoId) {
    const files: IVideoFile[] = entity[EntityTypes.VIDEO][scene.videoId]?.files;
    const imageFile = files?.find(t => t.type === VideoType.IMAGE);
    if (imageFile) return imageFile ? `/${imageFile.filename}` : null;
  }
  if (scene.imageId) return getImageFile(entity, scene.imageId);
}

export function getImageFile(entity, imageId, resolution = Resolutions.SMALL_512) {
  const files: IImageFile[] = entity[EntityTypes.IMAGE][imageId]?.files;
  return getImageFromFiles(files, resolution);
}

export function getImageFromFiles(files, resolution = Resolutions.SMALL_512) {
  const file = getPreferedImageFile(files, resolution);
  if (file) return `/${file.filename}`;
}
